const requiresAuthentication = (route) => {
  return route && route.meta && route.meta.roles && route.meta.roles.length
}

export default requiresAuthentication
